module.exports = __webpack_public_path__ + "static/media/4.6ade85e3.jpg";